import environment from '@/utils/constants';

export function getStripeKey() {
  return environment.STRIPE_KEY;
}

export function getFrontendUrl() {
  return 'https://embed.appointments.trainae.com/';
}
